<div *ngIf="isAllowed">
  @if (healthReportData) {
  <div class="header-container">
    <div class="title">
      {{healthReportData.name}}
    </div>
    @if (this.categoryType === 'urgentRequired') {
      <div class="discription">
        <div class="discription-title" i18n>Critical</div>
        <div class="discription-info" i18n>These are the critical findings on your vehicle that require immediate attention.</div>
      </div>
    }
    @if (this.categoryType === 'attentionRequired') {
      <div class="discription">
        <div class="discription-title" i18n>Attention required</div>
        <div class="discription-info" i18n>These findings require attention now or in the near future.</div>
      </div>
    }
    @if (this.categoryType === 'categoriesOk') {
      <div class="discription" >
        <div class="discription-title" i18n>Checked and Ok</div>
        <div class="discription-info" i18n>These parts of your vehicle are visually Ok</div>
      </div>
    }
  </div>
}


<div class="body-container small-block">
  @for (category of reportResponse?.categories; track category; let k = $index) {
    <div class="checklist-container">
      <div class="checklist-header">
        @if (isAtLeastOneCheckpointDisabled(category)) {
          <div>
            {{category?.name}}
          </div>
        }
      </div>
      <div class="checklist-body">
        @for (checkpoint of category?.checkpoints; track checkpoint; let j = $index) {
          <div class="checklist-accordion">
            @if (!checkpoint.isWalkthroughEnabled) {
              <mat-accordion>
                <mat-expansion-panel class="expansion-panel"
                  [expanded]="isCheckpointExpandable(checkpoint)"
                  [disabled]="!isCheckpointExpandable(checkpoint)">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <div class="radio-button">
                        @if (this.categoryType === 'urgentRequired') {
                          <img src="../../assets/common/radio-buttons/not-ok-red.svg"
                            alt="File not found." i18n-alt>
                        }
                        @if (this.categoryType === 'attentionRequired') {
                          <img src="../../assets/common/radio-buttons/not-ok.svg"
                            alt="File not found." i18n-alt>
                        }
                        @if (this.categoryType === 'categoriesOk') {
                          <img src="../../assets/common/radio-buttons/ok.svg"
                            alt="File not found." i18n-alt>
                        }
                        @if (checkpoint.status === 'Undefined') {
                          <img src="../../assets/common/radio-buttons/Undefined.svg"
                            alt="File not found." i18n-alt>
                        }
                      </div>
                      <div class="checkpoint-title">
                        {{checkpoint.description}}
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="expansion-panel-body">
                    <div class="checkpoint-description">
                      {{checkpoint.solution?.description}}
                    </div>
                    <div class="checkpoint-measuredValue">
                      {{checkpoint.measuredValues?.[0]?.value}}
                    </div>
                    @if (checkpoint.comment) {
                      <div class="checkpoint-measuredValue">
                        {{checkpoint.comment}}
                      </div>
                    }
                    @if (checkpoint?.media?.length?? 0 > 0) {
                      <div class="carousel-container">
                        <app-carousel id="{{j}}{{k}}" [media]="checkpoint.media" [isWalkthroughEnabled]="checkpoint.isWalkthroughEnabled" [introOutroMediaData]="introOutroMediaData"></app-carousel>
                      </div>
                    }
                    @if (checkpoint.measuredValues  && checkpoint.measuredValues[0]?.media) {
                      <div class="carousel-container">
                        <app-carousel id="{{j}}{{k}}" [media]="checkpoint.measuredValues[0].media" [isWalkthroughEnabled]="checkpoint.isWalkthroughEnabled" [introOutroMediaData]="introOutroMediaData"></app-carousel>
                      </div>
                    }
                    @for (findings of checkpoint?.findings; track findings; let l = $index) {
                      <div class="findings-container">
                        <div class="finding-description">
                          {{findings.findingType?.description}}
                        </div>
                        <div class="finding-solution">
                          {{findings.solution?.description}}
                        </div>
                        <div class="finding-comment">
                          {{findings.comment}}
                        </div>
                        @if (findings.media && findings.media.length > 0) {
                          <div class="carousel-container">
                            <app-carousel id="{{j}}{{k}}{{l}}" [media]="findings?.media" [isWalkthroughEnabled]="checkpoint.isWalkthroughEnabled" [introOutroMediaData]="introOutroMediaData"></app-carousel>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            }
          </div>
        }
      </div>
    </div>
  }
</div>

<div class="body-container largeblock">
  @if (reportResponse?.categories) {
    <div class="goto-top" (click)="scrollToElement('0')">
      <img class="goto-top-icon" src="../../assets/common/arrows/up-arrow.svg"
        alt="File not found." i18n-alt>
      </div>
    }
    <div class="category-list">
      <div class="category-list-items">
        @if (reportResponse?.categories) {
          <div class="category-text" i18n>Category</div>
        }
        @for (category of reportResponse?.categories; track category; let k = $index) {
          <a (click)="selectedCategoryIndex = k"
            [ngClass]="{'clicked': selectedCategoryIndex === k}" (click)="scrollToElement(k+'')">
            @if (isAtLeastOneCheckpointDisabled(category)) {
              <div>
                {{ category.name }}
              </div>
            }
          </a>
        }
      </div>
    </div>
    <div class="checklist-data-large">
      @if (selectedCategory || true;) {
        <div>
          <div class="checklist-body">
            @for (category of reportResponse?.categories; track category; let k = $index) {
              <div class="checklist-item">
                <div class="checklist-header" [attr.id]="k">
                  @if (isAtLeastOneCheckpointDisabled(category)) {
                    <div>
                      {{category.name}}
                    </div>
                  }
                </div>
                <div class="checklist-body">
                  @for (checkpoint of category?.checkpoints; track checkpoint; let j = $index) {
                    <div class="checklist-accordion">
                      @if (!checkpoint.isWalkthroughEnabled) {
                        <mat-accordion >
                          <mat-expansion-panel [expanded]="isCheckpointExpandable(checkpoint)"
                            [disabled]="!isCheckpointExpandable(checkpoint)">
                            <mat-expansion-panel-header>
                              <mat-panel-title>
                                <div class="radio-button">
                                  @if (this.categoryType === 'urgentRequired') {
                                    <img src="../../assets/common/radio-buttons/not-ok-red.svg"
                                      alt="File not found." i18n-alt>
                                  }
                                  @if (this.categoryType === 'attentionRequired') {
                                    <img src="../../assets/common/radio-buttons/not-ok.svg"
                                      alt="File not found." i18n-alt>
                                  }
                                  @if (this.categoryType === 'categoriesOk') {
                                    <img src="../../assets/common/radio-buttons/ok.svg"
                                      alt="File not found." i18n-alt>
                                  }
                                  @if (checkpoint.status === 'Undefined') {
                                    <img src="../../assets/common/radio-buttons/Undefined.svg"
                                      alt="File not found." i18n-alt>
                                  }
                                </div>
                                <div class="checkpoint-title">
                                  {{checkpoint.description}}
                                </div>
                              </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="expansion-panel-body">
                              <div class="checkpoint-description">
                                {{checkpoint.solution?.description}}
                              </div>
                              <div class="checkpoint-measuredValue">
                                {{checkpoint.measuredValues?.[0]?.value}}
                              </div>
                              @if (checkpoint.comment) {
                                <div class="checkpoint-measuredValue">
                                  {{checkpoint.comment}}
                                </div>
                              }
                              @if (checkpoint && checkpoint.measuredValues && checkpoint.measuredValues[0] &&
                                checkpoint.measuredValues[0].media && checkpoint.measuredValues[0].media.length > 0 || (checkpoint?.media)) {
                                <p class="gallery" i18n>Gallery</p>
                              }
                              @if (checkpoint?.media) {
                                <div class="media-list">
                                  @for (item of checkpoint?.media; track item; let j = $index) {
                                    <div [class.active]="j === 0">
                                      @if (item.mimeType.includes('video')) {
                                        <div class="large-screen-media-image">
                                          <mat-icon (click)="openMediaModal(checkpoint.media, j, checkpoint.isWalkthroughEnabled)"
                                          class="mat-play-icon">play_arrow</mat-icon>
                                          <a (click)="openMediaModal(checkpoint.media, j, checkpoint.isWalkthroughEnabled)">
                                            <img [src]="item.thumbnail?.url" alt="File not found." i18n-alt>
                                          </a>
                                        </div>
                                      }
                                      @if (item.mimeType.includes('Image')) {
                                        <div class="large-screen-media-image">
                                          <a (click)="openMediaModal(checkpoint.media, j, checkpoint.isWalkthroughEnabled)">
                                            <img [src]="item.url" alt="File not found." i18n-alt>
                                          </a>
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              }
                              @if (checkpoint?.measuredValues?.[0]?.media) {
                                <div class="media-list">
                                  @for (item of checkpoint.measuredValues?.[0]?.media; track item; let j = $index) {
                                    <div [class.active]="j === 0">
                                      @if (item.mimeType.includes('video')) {
                                        <div class="large-screen-media-image">
                                          <mat-icon (click)="openMediaModal(checkpoint.measuredValues?.[0]?.media, j, checkpoint.isWalkthroughEnabled)"
                                          class="mat-play-icon">play_arrow</mat-icon>
                                          <a (click)="openMediaModal(checkpoint.measuredValues?.[0]?.media, j, checkpoint.isWalkthroughEnabled)">
                                            <img [src]="item.thumbnail?.url" alt="File not found." i18n-alt>
                                          </a>
                                        </div>
                                      }
                                      @if (item.mimeType.includes('Image')) {
                                        <div class="large-screen-media-image">
                                          <a (click)="openMediaModal(checkpoint.measuredValues?.[0]?.media, j, checkpoint.isWalkthroughEnabled)">
                                            <img [src]="item.url" alt="File not found." i18n-alt>
                                          </a>
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              }
                              @if (checkpoint.findings) {
                                <div>
                                  @for (findings of checkpoint.findings; track findings) {
                                    <div>
                                      <div class="description">
                                        {{findings.findingType?.description}}
                                      </div>
                                      <div>
                                        {{findings.solution?.description}}
                                      </div>
                                      <div class="comment">
                                        {{findings.comment}}
                                      </div>
                                      @if (findings.media && findings.media.length>0) {
                                        <p class="gallery" i18n>Gallery</p>
                                      }
                                      @if (findings.media) {
                                        <div class="media-list">
                                          @for (item of findings?.media; track item; let j = $index) {
                                            <div [class.active]="j === 0">
                                              @if (item.mimeType.includes('video')) {
                                                <div class="large-screen-media-image">
                                                  <mat-icon (click)="openMediaModal(findings.media, j, checkpoint.isWalkthroughEnabled)"
                                                  class="mat-play-icon">play_arrow</mat-icon>
                                                  <a (click)="openMediaModal(findings.media, j, checkpoint.isWalkthroughEnabled)">
                                                    <img [src]="item.thumbnail?.url" alt="File not found." i18n-alt>
                                                  </a>
                                                </div>
                                              }
                                              @if (item.mimeType.includes('Image')) {
                                                <div class="large-screen-media-image">
                                                  <a (click)="openMediaModal(findings.media, j, checkpoint.isWalkthroughEnabled)">
                                                    <img [src]="item.url" alt="File not found." i18n-alt>
                                                  </a>
                                                </div>
                                              }
                                            </div>
                                          }
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          </mat-expansion-panel>
                        </mat-accordion>
                      }
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>

  <div class="backdrop"></div>
  <div class="modal" #imageModal tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title"></div>
          <button (click)="closeMediaModal()" type="button" class="close">
            <span>&times;</span>
          </button>
        </div>
        <div class="model-media-container">
          <div class="navigation-button">
            <mat-icon class="navigation-left"
            (click)="openMediaModal(modelMedia, correntSellectedModel-1)">keyboard_arrow_left</mat-icon>
          </div>
          <div class="modal-body">
            @if (mediaElememt === 'image') {
              <img [src]="modalImageUrl" class="d-block w-100" alt="modalImage">
            }
            @if (mediaElememt === 'video' && !(isWalkthroughEnabled && !isObjectEmpty(introOutroMediaData))) {
              <video id="model-video" #modelVideo autoplay controls>
                <source [src]="modalImageUrl" type="video/mp4">
                <source [src]="modalImageUrl" type="video/ogg">
                Your browser does not support the video.
              </video>
            }
            @if (mediaElememt === 'video' && (isWalkthroughEnabled && !isObjectEmpty(introOutroMediaData))) {
              <div class="video-player-large-div">
                @for (media of modelMedia; track media; let i = $index) {
                  <div class="video-player-large-child-div">
                    @if (i==correntSellectedModel) {
                      <app-video-player [media]="modelMedia[i]" [introOutroMediaData]="introOutroMediaData"></app-video-player>
                    }
                  </div>
                }
              </div>
            }
          </div>
          <div class="navigation-button">
            <mat-icon class="navigation-right"
            (click)="openMediaModal(modelMedia, correntSellectedModel+1)">keyboard_arrow_right</mat-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!isAllowed"></div>